// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var $$Array = require("rescript/lib/js/array.js");
var Curry = require("rescript/lib/js/curry.js");
var React = require("react");
var Belt_List = require("rescript/lib/js/belt_List.js");
var Belt_Array = require("rescript/lib/js/belt_Array.js");
var JsxRuntime = require("react/jsx-runtime");
var ImportEnrichmentActionStyles$ReactHooksTemplate = require("./ImportEnrichmentActionStyles.res.js");
var ImportEnrichmentFieldOptions$ReactHooksTemplate = require("./ImportEnrichmentFieldOptions.res.js");
var ImportEnrichmentActionHelpers$ReactHooksTemplate = require("./ImportEnrichmentActionHelpers.res.js");

function ImportEnrichmentLookupMappingBuilder(props) {
  var onChange = props.onChange;
  var fieldOptions = props.fieldOptions;
  var lookupMapText = props.lookupMapText;
  var match = React.useState(function (param) {
        return ImportEnrichmentActionHelpers$ReactHooksTemplate.ensureLookupRows(ImportEnrichmentActionHelpers$ReactHooksTemplate.parseLookupMapText(lookupMapText));
      });
  var setRows = match[1];
  var rows = match[0];
  React.useEffect((function (param) {
          var serialized = ImportEnrichmentActionHelpers$ReactHooksTemplate.serializeLookupMapRows(rows);
          if (lookupMapText !== serialized) {
            Curry._1(setRows, (function (param) {
                    return ImportEnrichmentActionHelpers$ReactHooksTemplate.ensureLookupRows(ImportEnrichmentActionHelpers$ReactHooksTemplate.parseLookupMapText(lookupMapText));
                  }));
          }
          
        }), [lookupMapText]);
  var sourceOptions = ImportEnrichmentActionHelpers$ReactHooksTemplate.listOptionsForPath(fieldOptions, props.sourcePath);
  var hasSourceList = sourceOptions.length !== 0;
  var field = ImportEnrichmentFieldOptions$ReactHooksTemplate.findByTarget(fieldOptions, props.targetKind, props.targetField);
  var targetOptions = field !== undefined ? field.listOptions : [];
  var hasTargetList = targetOptions.length !== 0;
  var duplicates = ImportEnrichmentActionHelpers$ReactHooksTemplate.lookupDuplicateSources(rows);
  var partialRows = ImportEnrichmentActionHelpers$ReactHooksTemplate.lookupPartialRows(rows);
  var commitRows = function (nextRows) {
    Curry._1(setRows, (function (param) {
            return nextRows;
          }));
    Curry._1(onChange, ImportEnrichmentActionHelpers$ReactHooksTemplate.serializeLookupMapRows(nextRows));
  };
  var updateRowAt = function (rowId, updater) {
    commitRows(Belt_List.map(rows, (function (row) {
                if (row.id === rowId) {
                  return Curry._1(updater, row);
                } else {
                  return row;
                }
              })));
  };
  var renderSourceInput = function (row) {
    if (hasSourceList) {
      return JsxRuntime.jsxs("select", {
                  children: [
                    JsxRuntime.jsx("option", {
                          children: "Choose a value",
                          value: ""
                        }),
                    Belt_Array.map(sourceOptions, (function (option) {
                            return JsxRuntime.jsx("option", {
                                        children: option,
                                        value: option
                                      }, option);
                          }))
                  ],
                  className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                  value: row.source,
                  onChange: (function (e) {
                      updateRowAt(row.id, (function (prev) {
                              return {
                                      id: prev.id,
                                      source: e.target.value,
                                      target: prev.target
                                    };
                            }));
                    })
                });
    } else {
      return JsxRuntime.jsx("input", {
                  className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                  placeholder: "e.g. US",
                  value: row.source,
                  onChange: (function (e) {
                      updateRowAt(row.id, (function (prev) {
                              return {
                                      id: prev.id,
                                      source: e.target.value,
                                      target: prev.target
                                    };
                            }));
                    })
                });
    }
  };
  var renderTargetInput = function (row) {
    if (hasTargetList) {
      return JsxRuntime.jsxs("select", {
                  children: [
                    JsxRuntime.jsx("option", {
                          children: "Choose a value",
                          value: ""
                        }),
                    Belt_Array.map(targetOptions, (function (option) {
                            return JsxRuntime.jsx("option", {
                                        children: option,
                                        value: option
                                      }, option);
                          }))
                  ],
                  className: ImportEnrichmentActionStyles$ReactHooksTemplate.selectBase,
                  value: row.target,
                  onChange: (function (e) {
                      updateRowAt(row.id, (function (prev) {
                              return {
                                      id: prev.id,
                                      source: prev.source,
                                      target: e.target.value
                                    };
                            }));
                    })
                });
    } else {
      return JsxRuntime.jsx("input", {
                  className: ImportEnrichmentActionStyles$ReactHooksTemplate.inputBase,
                  placeholder: "e.g. Americas",
                  value: row.target,
                  onChange: (function (e) {
                      updateRowAt(row.id, (function (prev) {
                              return {
                                      id: prev.id,
                                      source: prev.source,
                                      target: e.target.value
                                    };
                            }));
                    })
                });
    }
  };
  var isDuplicateSource = function (source) {
    if (source.trim() !== "") {
      return Belt_List.some(duplicates, (function (dup) {
                    return dup === source.trim();
                  }));
    } else {
      return false;
    }
  };
  return JsxRuntime.jsxs("div", {
              children: [
                JsxRuntime.jsxs("div", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "When this field says"
                            }),
                        JsxRuntime.jsx("span", {}),
                        JsxRuntime.jsx("span", {
                              children: "Save this value"
                            }),
                        JsxRuntime.jsx("span", {})
                      ],
                      className: "hidden sm:grid sm:grid-cols-[1fr_auto_1fr_auto] gap-3 text-xs font-semibold text-gray-500 uppercase tracking-wide px-1"
                    }),
                $$Array.of_list(Belt_List.map(rows, (function (row) {
                            return JsxRuntime.jsxs("div", {
                                        children: [
                                          JsxRuntime.jsxs("div", {
                                                children: [
                                                  renderSourceInput(row),
                                                  isDuplicateSource(row.source) ? JsxRuntime.jsx("p", {
                                                          children: "This source value is already mapped.",
                                                          className: ImportEnrichmentActionStyles$ReactHooksTemplate.validationErrorClass
                                                        }) : null
                                                ]
                                              }),
                                          JsxRuntime.jsx("span", {
                                                children: "→",
                                                className: "hidden sm:block text-gray-400 text-center pt-2"
                                              }),
                                          JsxRuntime.jsx("div", {
                                                children: renderTargetInput(row)
                                              }),
                                          JsxRuntime.jsx("button", {
                                                children: "Remove",
                                                "aria-label": "Remove mapping row",
                                                className: "text-xs font-medium text-gray-500 hover:text-firebrick disabled:opacity-40 pt-2",
                                                disabled: !ImportEnrichmentActionHelpers$ReactHooksTemplate.canRemoveLookupRow(rows, row),
                                                type: "button",
                                                onClick: (function (param) {
                                                    commitRows(ImportEnrichmentActionHelpers$ReactHooksTemplate.removeLookupRowAt(rows, row.id));
                                                  })
                                              })
                                        ],
                                        className: "grid grid-cols-1 sm:grid-cols-[1fr_auto_1fr_auto] gap-3 items-start"
                                      }, row.id);
                          }))),
                JsxRuntime.jsxs("button", {
                      children: [
                        JsxRuntime.jsx("span", {
                              children: "+"
                            }),
                        "Add mapping"
                      ],
                      className: "inline-flex items-center gap-1 text-sm font-medium text-lochmara hover:text-blue-800",
                      type: "button",
                      onClick: (function (param) {
                          commitRows(Belt_List.concatMany([
                                    rows,
                                    {
                                      hd: ImportEnrichmentActionHelpers$ReactHooksTemplate.newLookupRow(),
                                      tl: /* [] */0
                                    }
                                  ]));
                        })
                    }),
                Belt_List.length(partialRows) > 0 ? JsxRuntime.jsx("p", {
                        children: "Complete both sides of each mapping or clear unused rows.",
                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.validationErrorClass
                      }) : null,
                hasSourceList ? JsxRuntime.jsx("p", {
                        children: "Source values are loaded from the selected field's list options.",
                        className: ImportEnrichmentActionStyles$ReactHooksTemplate.hintClass
                      }) : null
              ],
              className: "space-y-3"
            });
}

var make = ImportEnrichmentLookupMappingBuilder;

exports.make = make;
/* react Not a pure module */
